import React from 'react';

export const ReduxPager: React.FunctionComponent<{}> = () => null;